import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'contact-details';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Contact Details',
};

const contactDetails = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { contactDetails };
